var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { Group } from '@@/Group';
export class UserInformationState {
    constructor() {
        this.basedialogState = new BaseDialogState();
        makeObservable(this);
        this.basedialogState.setHideFooter(true);
        this.basedialogState.setHeaderLabel("Details");
        this.basedialogState.onClose = () => this.setOpen(false);
    }
    setUser(u) {
        this.user = u;
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UserInformationState.prototype, "user", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], UserInformationState.prototype, "setUser", null);
let UserInformationDialog = class UserInformationDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    dialog() {
        var _a;
        return React.createElement(Box, { mt: '10px' },
            React.createElement(SimpleGrid, { columns: 4, spacing: 5, className: 'contact-table-header' },
                React.createElement(Box, null,
                    React.createElement(Text, null, "Organisation")),
                React.createElement(Box, null,
                    React.createElement(Text, null, (_a = this.props.state.user) === null || _a === void 0 ? void 0 : _a.name))));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
UserInformationDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], UserInformationDialog);
export { UserInformationDialog };
